import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import * as counter from '../../utils/counter';
import { isGuatemala, isTemplateDelta, is25Lotto, is25LottoKenya, isMML } from '../../utils/template';

let now = moment();

function Counter({ date, nextDate, prefix }) {
    const [days, setDays] = useState(null);
    const [hours, setHours] = useState(null);
    const [minutes, setMinutes] = useState(null);
    const [seconds, setSeconds] = useState(null);
    const [then, setThen] = useState(moment(date));
    const { t } = useTranslation();

    const separateDigits = isTemplateDelta() || isGuatemala() || is25Lotto() || is25LottoKenya() || isMML;

    useEffect(() => {
        count();
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            if (then.diff(now) < 0) {
                setThen(moment(nextDate));
            }
            count();
        }, 1000);
        return () => {
            clearInterval(interval);
        };
    }, [then]);

    function count() {
        now = moment();
        setDays(counter.getDiffInDays(then, now));
        setHours(counter.getDiffInHours(then, now));
        setMinutes(counter.getDiffInMinutes(then, now));
        setSeconds(counter.getDiffInSeconds(then, now));
    }

    function show() {
        if (days === null || hours === null || minutes === null || seconds === null) return false;
        return true;
    }

    function getContent() {
        return (
            <div
                className="counter countdown"
                id="counter"
                data-date={moment(date).unix()}
                data-next-date={moment(nextDate).unix()}
            >
                <div className="row font-black clearfix">
                    {prefix && <span className="mr-2 font-weight-normal">{prefix}</span>}{' '}
                    {days > 0 && (
                        <div className={'counter-col time float-left ' + (days > 0 ? 'notfaded' : '')}>
                            <div className="time-img">
                                <span
                                    className="counter-bg counter-days"
                                    dangerouslySetInnerHTML={{ __html: counter.displayNumber(days, separateDigits) }}
                                />
                                <div className="time-line"></div>
                            </div>
                            <div className="time-name">{days === 1 ? t('counter.day') : t('counter.days')}</div>
                        </div>
                    )}
                    <div className={'counter-col time float-left ' + (hours > 0 || days > 0 ? 'notfaded' : '')}>
                        <div className="time-img">
                            <span
                                className="counter-bg counter-hours"
                                dangerouslySetInnerHTML={{ __html: counter.displayNumber(hours, separateDigits) }}
                            />
                            <div className="time-line"></div>
                        </div>
                        <div className="time-name">{hours === 1 ? t('counter.hour') : t('counter.hours')}</div>
                    </div>
                    <div
                        className={
                            'counter-col time float-left ' + (minutes > 0 || hours > 0 || days > 0 ? 'notfaded' : '')
                        }
                    >
                        <div className="time-img">
                            <span
                                className="counter-bg counter-minutes"
                                dangerouslySetInnerHTML={{ __html: counter.displayNumber(minutes, separateDigits) }}
                            />
                            <div className="time-line"></div>
                        </div>
                        <div className="time-name">{minutes === 1 ? t('counter.minute') : t('counter.minutes')}</div>
                    </div>
                    {days === 0 && (
                        <div
                            className={
                                'counter-col time float-left ' +
                                (seconds > 0 || minutes > 0 || hours > 0 || days > 0 ? 'notfaded' : '')
                            }
                        >
                            <div className="time-img">
                                <span
                                    className="counter-bg counter-seconds"
                                    dangerouslySetInnerHTML={{ __html: counter.displayNumber(seconds, separateDigits) }}
                                />
                                <div className="time-line"></div>
                            </div>
                            <div className="time-name">
                                {seconds === 1 ? t('counter.second') : t('counter.seconds')}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return show() ? getContent() : null;
}

export default Counter;
